import { CIcon } from '~/icons/types'
export const ciList: CIcon = {
  width: 448,
  height: 512,
  paths: [
    {
      d:
        'M432 0H16C7.2 0 0 7.2 0 16v40c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM144 355H16c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm288-1h-72v-68c0-8.8-7.2-16-16-16h-40c-8.8 0-16 7.2-16 16v68h-72c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h72v70c0 8.8 7.2 16 16 16h40c8.8 0 16-7.2 16-16v-70h72c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm0-188H16c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16z'
    }
  ],
  name: 'list',
  type: 'solid'
}
